// extracted by mini-css-extract-plugin
module.exports = {"container":"_2kSb-YJWda-l4ziOkss-6J","visible":"RhjoMU5rFlito-XgLBMfp","cancelBtn":"_3JTqGOQlLWe5A_QhcTFvxF","icon":"_1bWnMKcnxHdSf-UwskGOfz","saveBtn":"_1AVELxJow6XtAuBXQ9KPDb"};